module.exports = __webpack_public_path__ + "static/media/ending-light-holl.7e18e9cc.png";